import { render, staticRenderFns } from "./Informs.vue?vue&type=template&id=54d4a91e&scoped=true"
import script from "./Informs.vue?vue&type=script&lang=js"
export * from "./Informs.vue?vue&type=script&lang=js"
import style0 from "./Informs.vue?vue&type=style&index=0&id=54d4a91e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4a91e",
  null
  
)

export default component.exports